
//https://devicon.dev/

//https://icons8.com/icons

const icoHtml='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/html5/html5-original.svg'
const icoCss='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/css3/css3-original.svg' 
const icoBoo= 'https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/bootstrap/bootstrap-original.svg' 
const icoSas='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/sass/sass-original.svg'
const icoGitHub='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/github/github-original-wordmark.svg'
const icoGitLab='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/gitlab/gitlab-original-wordmark.svg' 
const icoJs='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/javascript/javascript-original.svg'
const icoRea='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/react/react-original.svg'
const icoNpm='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/npm/npm-original-wordmark.svg'
const icoNodeJs='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/nodejs/nodejs-plain-wordmark.svg' 
const icoMon= 'https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/mongodb/mongodb-original-wordmark.svg' 
const icoDocker='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/docker/docker-original.svg' 
const icoHan='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/handlebars/handlebars-original-wordmark.svg' 
const icoFir='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/firebase/firebase-plain-wordmark.svg' 
const icoGit='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/git/git-original.svg' 
const icoFileZ='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/filezilla/filezilla-plain.svg'
const icoSocketio='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/socketio/socketio-original-wordmark.svg'
const icoMocha='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/mocha/mocha-plain.svg'
const icoExpress='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/express/express-original-wordmark.svg'
const iconCsharp='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/csharp/csharp-original.svg'
const icoJwt='https://img.icons8.com/?size=512&id=rHpveptSuwDz&format=png'
const icoNodemon='https://img.icons8.com/?size=512&id=8e6sgfGHgI9t&format=png'
const icoNodeMailer='https://nodemailer.com/nm_logo_200x136.png'
const icoPassport='https://www.passportjs.org/images/logo.svg'
const icoArtillery='https://avatars.githubusercontent.com/u/12608521?s=280&v=4'
const icoFullResponive='https://img.icons8.com/?size=512&id=J2dBOvzdU328&format=png'
const icoSwagger='https://static-00.iconduck.com/assets.00/swagger-icon-512x512-halz44im.png'
const icoFigma='https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/figma/figma-original.svg'
//Software
const icoVisualStudio='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/visualstudio/visualstudio-plain.svg'
const icoVisualCode='https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/vscode/vscode-original.svg'
const icoPhotoshop='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/photoshop/photoshop-plain.svg'
const icoAillustraitor='https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/illustrator/illustrator-plain.svg'
const icoOffice='https://img.icons8.com/?size=512&id=vIbsCQXkSp6l&format=png'
const icoPostman='https://img.icons8.com/?size=512&id=EPbEfEa7o8CB&format=png'
const icoResponsively='https://avatars.githubusercontent.com/u/69102126?s=200&v=4'
const icoSQLServer='https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/microsoftsqlserver/microsoftsqlserver-original-wordmark.svg'


export{
    icoFigma,
    icoSQLServer,
    icoHtml,
    icoCss,
    icoBoo,
    icoSas,
    icoJs,
    icoRea,
    icoNpm,
    icoNodeJs,
    icoMon,
    icoDocker,
    icoFullResponive,
    icoHan,
    icoFir,
    icoJwt,
    icoGit,
    icoNodeMailer,
    icoNodemon,
    icoSocketio,
    icoMocha,
    icoExpress,
    icoArtillery,
    icoPassport,
    icoFileZ,
    iconCsharp,
    icoGitHub,
    icoGitLab,
    icoVisualCode,
    icoVisualStudio,
    icoPhotoshop,
    icoAillustraitor,
    icoOffice,
    icoPostman,
    icoSwagger,
    icoResponsively
}